export default __webpack_public_path__ + "static/media/youtube.c66c6746.svg";